import SP from 'constants/ui/sidePanel.const';
import logger from 'utils/logger.util';

const L = logger('determineIfDisabledDrag'); // eslint-disable-line no-unused-vars

const determineIfDisabledDrag = (options) => {
  if (SP.timeOff === options?.panel) return true;
  if (SP.timeOffCat === options?.panel) return true;
  if (options?.modal) return true;
  // noinspection RedundantIfStatementJS
  if (options?.editing) return true;

  return false;
};

export default determineIfDisabledDrag;
